<template>
	<div />
</template>
<script>
	export default {
		created() {
			this.$store.dispatch('user/removeUserSession').then(() => {
				this.$router.go()
			})
		}
	}
</script>